import React from 'react';
const ModalContext = /*#__PURE__*/React.createContext(undefined);
export default ModalContext;
//# sourceMappingURL=ModalContext.js.map